import { render, staticRenderFns } from "./DrinkCardBeer.vue?vue&type=template&id=7108e7fc&scoped=true&"
import script from "./DrinkCardBeer.vue?vue&type=script&lang=js&"
export * from "./DrinkCardBeer.vue?vue&type=script&lang=js&"
import style0 from "./DrinkCardBeer.vue?vue&type=style&index=0&id=7108e7fc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108e7fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrinkCard: require('/opt/build/repo/components/DrinkCard.vue').default})
